import React from "react";
import { AlertCircle, CheckCircle2 } from "lucide-react";

const PROBLEMS = [
  {
    problem: "No sé por dónde empezar con mis impuestos y me da miedo cometer un error con el IRS.",
    solution:
      "Preparamos tu declaración de impuestos personal o de negocio de forma correcta, buscando cada deducción legal a tu favor. Te explicamos todo paso a paso.",
  },
  {
    problem: "Quiero abrir mi negocio en Estados Unidos, pero no entiendo el papeleo ni por dónde arrancar.",
    solution:
      "Te ayudamos a constituir tu LLC o entidad comercial de principio a fin: nombre, EIN, documentos y estructura óptima según tu caso.",
  },
  {
    problem: "No tengo Social Security y necesito cumplir con obligaciones fiscales.",
    solution:
      "Tramitamos tu ITIN para que puedas declarar impuestos, abrir cuentas y estar en regla con el IRS, todo con acompañamiento personalizado.",
  },
  {
    problem: "Necesito notarizar un documento urgente y no sé a dónde ir.",
    solution:
      "Como Notary Public certificada del estado de Florida, notarizamos poderes, declaraciones, firmas y documentos con validez oficial.",
  },
  {
    problem: "Llevo mi negocio pero mis cuentas son un caos y no sé cuánto realmente gano.",
    solution:
      "Organizamos tu contabilidad y bookkeeping mes a mes. Tendrás reportes claros, listos para impuestos y para tomar decisiones inteligentes.",
  },
  {
    problem: "Debo llenar formularios migratorios y no sé cómo hacerlo correctamente.",
    solution:
      "Te asistimos en el llenado de formularios migratorios con detalle y precisión (asistencia únicamente, sin representación legal).",
  },
  {
    problem: "Quiero proteger a mi familia con un seguro pero hay demasiadas opciones.",
    solution:
      "Te asesoramos en seguros de vida y seguros médicos, comparando opciones para encontrar la póliza correcta según tu presupuesto y necesidades.",
  },
];

export default function ProblemSolution() {
  return (
    <section id="soluciones" className="py-24 lg:py-32 bg-[#0f172a] text-white relative overflow-hidden" data-testid="problem-solution-section">
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-[#0B2D5C]/20 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-[#C89B2C]/10 rounded-full blur-3xl"></div>

      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-14 relative">
        {/* Sticky left */}
        <div className="lg:col-span-5">
          <div className="lg:sticky lg:top-32 reveal">
            <div className="text-xs font-semibold text-[#C89B2C] tracking-[0.2em] uppercase mb-4">
              Cómo puedo ayudarte
            </div>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold leading-[1.1] mb-6">
              ¿Cómo puedo solucionar{" "}
              <span className="text-[#C89B2C]">tus problemas?</span>
            </h2>
            <p className="text-lg text-white/70 leading-relaxed mb-8">
              Cada cliente llega con una situación única. Aquí te muestro las preocupaciones más comunes que resolvemos
              todos los días, y cómo lo hacemos.
            </p>
            <button
              onClick={() => document.querySelector("#contacto")?.scrollIntoView({ behavior: "smooth" })}
              className="inline-flex items-center gap-2 bg-[#C89B2C] hover:bg-[#A67D1F] text-[#0f172a] font-semibold px-6 py-3 rounded-sm transition-colors"
              data-testid="problem-solution-cta"
            >
              Cuéntame tu caso
            </button>
          </div>
        </div>

        {/* Scrolling right */}
        <div className="lg:col-span-7 flex flex-col gap-5">
          {PROBLEMS.map((p, i) => (
            <div
              key={i}
              className="reveal bg-white/5 border border-white/10 backdrop-blur-sm p-7 rounded-sm hover:border-[#C89B2C]/50 transition-colors"
              style={{ transitionDelay: `${i * 40}ms` }}
              data-testid={`problem-item-${i}`}
            >
              <div className="flex gap-4 mb-4">
                <AlertCircle className="text-[#C89B2C] flex-shrink-0 mt-0.5" size={20} strokeWidth={1.75} />
                <p className="text-white/90 text-[15px] leading-relaxed italic">"{p.problem}"</p>
              </div>
              <div className="flex gap-4 pt-4 border-t border-white/10">
                <CheckCircle2 className="text-[#34d399] flex-shrink-0 mt-0.5" size={20} strokeWidth={1.75} />
                <p className="text-white text-[15px] leading-relaxed">
                  <span className="text-[#C89B2C] font-semibold">Solución: </span>
                  {p.solution}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
